import React from "react";
import { NavLink } from "react-router-dom";

import { Header } from '../../Components/Layout/Header.jsx';
import { GameDetails } from '../../Components/Game/GameDetails.jsx';
import { ObavijestiCasino } from '../../Components/Layout/ObavijestiCasino.jsx';
import { Game } from '../../Components/Game/Game.jsx';

import { MetaTags } from '../../Components/Layout/MetaTags.jsx';
import { LiveDobitci } from '../../Components/Casino/LiveDobitci.jsx';
import { HorizontalItems } from '../../Components/Layout/HorizontalItems.jsx';

export class Winners extends React.Component {
    constructor(props) {
        super(props);
        this.state = { jackpots: null, igre: null, selectedTab: 'posljednji' }

        this.setData = this.setData.bind(this);
        this.renderIgra = this.renderIgra.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.checkFloatingElement = this.checkFloatingElement.bind(this);
        this.renderTable = this.renderTable.bind(this);
        this.renderDobitnikRow = this.renderDobitnikRow.bind(this);
        this.renderContent = this.renderContent.bind(this);

        window.addEventListener("scroll", this.handleScroll, false);
        this.downFixedContainer = React.createRef();
        this.downFixed = React.createRef();

        casino.utils.createPageGoogleTagManagerEvent('Dobitnici', 'Posljedni izdvojeni dobici', 'casino', this.props.user);
    }

    handleScroll() {
        cancelAnimationFrame(this.animationFrame)
        this.animationFrame = requestAnimationFrame(this.checkFloatingElement);
    }

    checkFloatingElement() {
        let wScrool = window.scrollY;

        if (this.oldScrool != wScrool) {
            let scroolOffset = this.downFixedContainer.current.offsetTop - window.innerHeight + this.downFixedContainer.current.offsetHeight;
            this.oldScrool = wScrool;
            if (wScrool > scroolOffset) {
                this.downFixed.current.classList.add("stop")
            }
            else {
                this.downFixed.current.classList.remove("stop")
            }
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.showMenuFn(false);

        // Read URL param and set active tab
        const urlParams = new URLSearchParams(window.location.search);
        const tab = urlParams.get('tab');
        const validTabs = ['posljednji', 'najveci'];
        if (tab && validTabs.includes(tab)) {
            this.setState({ selectedTab: tab });
        }

        this.props.showLoadingFn(true);
        const promises = Promise.all([casino.repos.casinoDobitciRepo.get(), casino.repos.gameRepo.list(), casino.repos.categoryRepo.list()]);
        this.dataPromise = casino.utils.makeCancelablePromise(promises);
        this.dataPromise.promise.then(this.setData, function (reason) { });

        this.animationFrame = requestAnimationFrame(this.handleScroll);
    }

    componentWillUnmount() {
        cancelAnimationFrame(this.animationFrame);
        window.removeEventListener("scroll", this.handleScroll, false);

        this.dataPromise.cancel();
        this.props.showLoadingFn(false);
    }

    setData(responseData) {
        const { sviJackpoti, sviJackpotiKuna, sviJackpotiEuro, najveciJackpotDobitci, najveciDobitci, mojiNajveciDobitci, posljednji, posljednjiJackpotDobitci, najveciDobiciUMomKraju } = responseData[0];
        const { items } = responseData[1];
        const categories = responseData[2].items;
        this.setState({
            sviJackpoti,
            sviJackpotiKuna,
            sviJackpotiEuro,
            najveciJackpotDobitci,
            najveciDobitci,
            mojiNajveciDobitci,
            posljednji,
            najveciDobiciUMomKraju,
            igre: items,
            posljednjiJackpotDobitci: posljednjiJackpotDobitci,
            categories: categories,
            moji: false
        });

        this.props.showLoadingFn(false);
    }

    createGoogleTagEvent(dobitnik) {
        const igra = this.state.igre.find(it => it.s == dobitnik.igraSifra);
        if (igra && this.state.categories) {
            let kategorijeArray = [];
            Object.keys(igra.kt).forEach(key => {
                const filterKategorija = this.state.categories.find(x => x.id == key);
                if (filterKategorija)
                    kategorijeArray.push(filterKategorija.name);
            });
            casino.utils.createGoogleTagManagerEvent({
                'event': 'game_click',
                'game_name': igra.n,
                'game_provider': this.props.brands[igra.bID].name,
                'game_type': kategorijeArray ? kategorijeArray.join() : '',
                'jackpot': igra.jp ? 'yes' : 'no',
                'jackpot_amount': igra.jp ? igra.jp : 0,
                'gameId': igra.id
            });
        }
    }

    renderIgra(igra) {
        return <Game brands={this.props.brands} key={igra.sifra + igra.jpIznos.toString()} showJackpot={false} routePrefix="/winners" igra={igra} gameNameclassName="text-center" />
    }

    renderTable(dobitnici) {
        return <table className="table-1 v2 v3" style={{ tableLayout: 'fixed' }}>
            <tbody>
                {dobitnici.map(this.renderDobitnikRow)}
            </tbody>
        </table>
    }

    renderDobitnikRow(dobitnik, i) {
        const datum = new Date(dobitnik.datum);
        const igra = this.state.igre.find(it => it.s == dobitnik.igraSifra);

        let maintenanceClass = dobitnik?.odrzavanje ? ' maintenance' : '';
        if (i > 20)
            return null;

        return <tr key={i} className={i > 0 && i < 20 ? "horizontal-lines" + maintenanceClass : "" + maintenanceClass}>
            <td>
                <span className="text text-29 text-ellipsis">
                    {casino.utils.dateToDateString(datum)} u {casino.utils.dateToTimeString(datum)}
                </span>
                {igra && <NavLink to={{ pathname: '/winners/game/' + this.props.brands[igra.bID].nameNormalizirano + '/' + casino.utils.normalizeString(dobitnik.urlName) }} onClick={() => this.createGoogleTagEvent(dobitnik)}>
                    <div className='text text-23 text-ellipsis'>
                        {dobitnik.igraNaziv}
                    </div>
                </NavLink>}
                {!igra &&
                    <div className='text text-23 text-ellipsis'>
                        {dobitnik.igraNaziv}
                    </div>
                }
            </td>

            {!this.state.moji && <td> <div className='text text-28 text-ellipsis text-center'>{dobitnik?.igrac}</div> </td>}
            {!this.state.moji && <td className="text-right">
                <div className="dobitak-iznos pull-right smaller" >
                    <div className="iznos text-ellipsis">
                        {casino.utils.numberWithCurrencyFromated(dobitnik.dobitak, dobitnik.valuta)}</div>
                </div>
            </td>}
            {this.state.moji && <td className="multiplikator align-right border-bottom">
                <div className="tecaj-container">
                    <div className="icons">
                        <span className="icon-1"></span>
                        <span className="icon-2"></span>
                    </div>
                    <div className="tecaj">x {casino.utils.numberToString(dobitnik.tecaj)}</div>
                </div>
            </td>}
        </tr>
    }

    renderContent() {
        return (
            <div className="white-background">
                <div className="winners-bg">
                    <div className="winners-bg--inner">
                        <div className="poker-container-wide " style={{ padding: '1rem 0rem 1rem' }}>
                            <div className="text-center text text-24" >
                                U JACKPOTIMA te još čeka
                            </div>
                            {!this.state.sviJackpoti && <div className="loader2" style={{ height: '10rem' }}></div>}
                            {this.state.sviJackpoti && <div className="jackpot-dobitci-container margin-top-xsmall text-center dobitnici">
                                <div className="jackpot-iznos-img"></div>
                                <div className="iznos text-ellipsis">
                                    {casino.utils.numberWithCurrencyFromated(this.state.sviJackpoti)}
                                </div>
                            </div>}
                        </div>

                        <div className="poker-container-wide no-padding" style={{ marginTop: '-10px' }} >
                            {this.state.najveciJackpotDobitci && <div className=" text text-25 text-center">NAJVEĆI JACKPOT DOBICI</div>}
                            {/* {!this.state.najveciJackpotDobitci && <div className="loader2" style={{ height: '18rem' }}></div>} */}
                            {this.state.najveciJackpotDobitci && <HorizontalItems brands={this.props.brands} categories={this.state.categories} items={this.state.najveciJackpotDobitci} routePrefix="/winners" from="dobitnici" jackpotGamesWin={true} hideNavigation={true} igre={this.state.igre} autoScrool={false} />}
                        </div>
                    </div>
                </div>
                <div className="poker-container-wide winners-tab no-padding ">
                    <table>
                        <tbody>
                            <tr>
                                <td onClick={() => { this.setState({ selectedTab: 'posljednji', moji: false }); casino.utils.createPageGoogleTagManagerEvent('Dobitnici', 'Posljedni izdvojeni dobici', 'casino', this.props.user) }} className={"text-center dobitnici-nav " + (this.state.selectedTab == 'posljednji' ? 'active' : '')}>&nbsp;&nbsp; POSLJEDNJI &nbsp;</td>
                                {this.props.user && <td onClick={() => { this.setState({ selectedTab: 'mojiNajveci', moji: true }); casino.utils.createPageGoogleTagManagerEvent('Dobitnici', 'Moji Najveci dobici', 'casino', this.props.user) }} className={"text-center dobitnici-nav " + (this.state.selectedTab == 'mojiNajveci' ? 'active' : '')}>&nbsp; MOJI &nbsp;</td>}
                                <td onClick={() => { this.setState({ selectedTab: 'najveci', moji: false }); casino.utils.createPageGoogleTagManagerEvent('Dobitnici', 'Najveci dobici', 'casino', this.props.user) }} className={"text-center dobitnici-nav " + (this.state.selectedTab == 'najveci' ? 'active' : '')}>&nbsp; NAJVEĆI &nbsp;</td>
                                <td onClick={() => { this.setState({ selectedTab: 'jackpot', moji: false }); casino.utils.createPageGoogleTagManagerEvent('Dobitnici', 'Jackpot dobici', 'casino', this.props.user) }} className={"text-center dobitnici-nav " + (this.state.selectedTab == 'jackpot' ? 'active' : '')}>&nbsp; JACKPOT &nbsp;&nbsp;</td>
                                {this.props.user && <td onClick={() => { this.setState({ selectedTab: 'lokalni', moji: false }); casino.utils.createPageGoogleTagManagerEvent('Dobitnici', 'Najveci dobici u mom kraju', 'casino', this.props.user) }} className={"text-center dobitnici-nav " + (this.state.selectedTab == 'lokalni' ? 'active' : '')}>&nbsp; LOKALNI &nbsp;</td>}
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="poker-container-wide no-padding " style={{ minHeight: '30rem' }}>
                    {/* {!this.state.igre && <div className="loader2" style={{ height: '15rem' }}></div>} */}
                    {this.state.igre && this.state.selectedTab == 'posljednji' && <div>{this.renderTable(this.state.posljednji)}</div>}
                    {this.state.igre && this.state.selectedTab == 'mojiNajveci' && <div>{this.renderTable(this.state.mojiNajveciDobitci)}</div>}
                    {this.state.igre && this.state.selectedTab == 'najveci' && <div>{this.renderTable(this.state.najveciDobitci)}</div>}
                    {this.state.igre && this.state.selectedTab == 'jackpot' && <div>{this.renderTable(this.state.posljednjiJackpotDobitci)}</div>}
                    {this.state.igre && this.state.selectedTab == 'lokalni' && <div>{this.renderTable(this.state.najveciDobiciUMomKraju)}</div>}
                    <br />
                </div>
                <div className="down-fixed-container" ref={this.downFixedContainer}>
                    <div className="down-fixed" ref={this.downFixed}>
                        <div className="live-dobitci-container">
                            <LiveDobitci categories={this.state.categories} brands={this.props.brands} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        return (
            <>
                <MetaTags title="Dobitnici | Jackpot, Posljednji i Najveći Casino Dobici | SuperSport Casino | SuperCasino" description={"Zavirite u listu dobitnika. Posljedni dobici, najveći dobici i jackpot dobici na jednom mjestu. Zaigraj omiljenu igru i priključi se listi dobitnika. SuperCasino"} />
                <Header key="header" {...this.state} {...this.props} />

                {this.renderContent()}

                <GameDetails {...this.props} {...this.state} brands={this.props.brands} routePrefix="/winners" PageName="Dobitnici" />
                <ObavijestiCasino {...this.props} />
            </>
        )
    }

};